<div class="header-container">
  <div class="inner d-flex justify-content-between w-100">
    <div class="customer-policy w-100">
      <div class="d-flex w-100">
        <span class="d-flex w-100">
          <span class="policy">
            <img class="pr-2" src="assets/img/svg/newspaper.svg" alt="" />
            <span class="heading-header"> Policy Number: </span>
            <span class="no">{{ inspection?.policyNumber }}</span>
          </span>
          <span class="customer">
            <img class="pr-2" src="assets/img/svg/customer.svg" alt="" />
            <span class="heading-header"> Customer: </span>
            <span class="name">{{ inspection?.customerName }}</span>
          </span>
        </span>
        <div class="btns-dropdown">
          <div class="dropdown" dropdown>
            <button
              id="mainDropdownBtn"
              dropdownToggle
              type="button"
              class="btn btn-primary dropdown-toggle"
              aria-controls="dropdown-basic">
              <span style="margin-right: 2px; margin-left: 0px" [ngClass]="selectedStatus.colorClass + ' dot'"></span>
              <span class="pr-1 selected-label"> {{ selectedStatus.label }}</span>
              <!-- <i class="fa fa-chevron-down" aria-hidden="true"></i> -->
            </button>

            <ul
              id="dropdown-basic"
              [ngStyle]="{ inset: '100% auto auto 0px' }"
              *dropdownMenu
              class="dropdown-menu"
              role="menu"
              aria-labelledby="mainDropdownBtn">
              <li *ngFor="let s of statuses">
                <a class="dropdown-item" (click)="updateUnderwritingStatus(s.id)">
                  <span [ngClass]="s.colorClass + ' dot'"></span>
                  {{ s.label }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-between w-100" style="padding-top: 16px">
        <div class="calendar">
          <span class="immediate-calendar"
            ><span class="immediate-recs">Immediate Recs Due:</span>
            <span
              class="dates"
              (click)="openCalendarModal('Immediate Recs Due', inspection.violationActionRequiredDeadline)">
              <img src="assets/img/svg/red-calendar.svg" alt="" />
              {{ inspection?.violationActionRequiredDeadline | date: 'MM/dd/yyyy' }}
            </span>
          </span>
          <span class="other-calendar"
            ><span class="other-recs">Other Recs Due:</span>
            <span class="dates" (click)="openCalendarModal('Other Recs Due', inspection.violationRecommendedDeadline)">
              <img src="assets/img/svg/yellow-calendar.svg" alt="" />{{
                inspection?.violationRecommendedDeadline | date: 'MM/dd/yyyy'
              }}
            </span>
          </span>
        </div>

        <div class="header-actions">
          <!-- View Journal Button -->
          <div class="view-journal-btn" (click)="toggleJournalPanel()">
            <img src="assets/img/svg/journal-book.svg" width="24" height="24" alt="Journal" />
            <span class="view-journal-text">View Journal</span>
          </div>

          <!-- Generate Report Dropdown -->
          <div class="generate-report-dropdown">
            <div class="dropdown-button" (click)="toggleDropdown()">
              <div class="button-content">
                <div class="text">Generate Report</div>
              </div>
              <div class="arrow-container">
                <svg
                  width="14"
                  height="6"
                  viewBox="0 0 14 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  [class.rotated]="isDropdownOpen">
                  <path
                    d="M1 1L7 5L13 1"
                    stroke="#6D7275"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </div>
            </div>

            <div class="dropdown-menu" *ngIf="isDropdownOpen">
              <div class="menu-item-wrapper" [class.disabled]="!showReportButton">
                <div
                  class="menu-item"
                  [class.disabled]="!showReportButton"
                  (click)="showReportButton ? openGenerateLetterModal() : null">
                  <div class="item-content">
                    <div class="icon-container">
                      <img src="assets/img/svg/generate-letter.svg" alt="Generate Letter" class="menu-icon" />
                    </div>
                    <div class="item-text">Generate Letter</div>
                  </div>
                </div>
                <div class="tooltip" *ngIf="!showReportButton">
                  All flags/groups must be completed before a letter can be created.
                </div>
              </div>
              <div class="menu-item-wrapper" [class.disabled]="!showReportButton">
                <div
                  class="menu-item"
                  [class.disabled]="!showReportButton"
                  (click)="showReportButton ? openPreviewLetterModal() : null">
                  <div class="item-content">
                    <div class="icon-container">
                      <img src="assets/img/svg/preview-rec.svg" alt="Preview Letter" class="menu-icon" />
                    </div>
                    <div class="item-text">Preview Letter</div>
                  </div>
                </div>
                <div class="tooltip" *ngIf="!showReportButton">
                  All flags/groups must be completed before a letter can be created.
                </div>
              </div>
              <div class="menu-item" (click)="openLetterHistoryPanel()">
                <div class="item-content">
                  <div class="icon-container">
                    <img src="assets/img/svg/history-letter.svg" alt="History of Letters" class="menu-icon" />
                  </div>
                  <div class="item-text">History of Letters</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-calendar-modal
  [selectedDateInput]="selectedDate"
  [selectedDateType]="selectedDateType"
  (selectedDate)="onSave($event)"></app-calendar-modal>

<app-generate-letter-modal
  [isOpen]="showGenerateLetterModal"
  (close)="closeGenerateLetterModal()"
  [isPreviewLetter]="isPreviewLetterOpen"
  (create)="handleCreateLetter($event)"
  (previewLetter)="handlePreviewLetter($event)"></app-generate-letter-modal>

<app-journal-sidebar
  [isVisible]="showJournalPanel"
  [inspectionId]="inspection?.id"
  (closePanel)="showJournalPanel = false"></app-journal-sidebar>
